// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-1aca462f]{width:100%;height:calc(100% - 1.5625rem)}", ""]);
// Exports
module.exports = exports;
